
// export const baseUrl = 'https://loyaltysintexapi.evolve-brands.co/api/v1/' //prod
// export const baseUrl = 'http://loyalty.sintex2.api.wemonde.co/api/v1/' //staging
export const baseUrl = 'https://loyalty.sintex-territory.api.wemonde.co/api/v1/' // New Stage URL
export const av = "1.0";
export const pt = "WEBSITE";
export const company = "1"
export const program = "1"
export const program2 = "2"